import { Modal } from "react-bootstrap";
import { useState } from "react";
import { shareCode } from "../../../../../../../actions/appsMoreAction";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../../../../../utils";

const ShareEmailCampaignCode = ({ setClosePopup, shareurl, message }) => {

  const [email, setEmail] = useState('');
  const [loader, setLoader] = useState(false);

  const sendCodeNew = () => {

    if (email.trim().length > 0) {
      setLoader(true);
      const code = { 'email': email, 'type': 5, 'htmlCode': `${shareurl}`, }
      shareCode(code).then((res) => {
        if (res.data.status) {
          setTimeout(() => {
            TOAST_SUCCESS('Email Campaign Code successfully shared.')
            setLoader(false)
            setClosePopup(false)
          }, 1000);
        } else {
          TOAST_ERROR(res.data.message);
        }
      })
    } else
      TOAST_ERROR('Please fill mail Id');
  }


  return (
    <>
      <Modal dialogClassName=" modal-dialog modal-dialog-centered modal-md personalizePopupModal dynamic-popup"
        size="lg" show={true} backdrop="static">
        <Modal.Body>
          <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={(e) => { setClosePopup(false) }} > </button>
          <div className="p-8">
            <div className="pt-4 text-center">
            </div> <div className="mb-7 text-center">
              <h2 className="font-weight-boldest font-size-h2 mb-3">Send Url by email</h2>
              <p className="font-size-lg">Share this Hashtag Campaign Url with your team. Enter the email Id to send the code directly to them</p>
            </div>
            <div className="from-group">
              <textarea name="data[Wall][emails]" placeholder="Ex: support@socialwalls.com,info@taggbox.com" label="Emails" className="form-control form-control-lg" value={email} onChange={(e) => setEmail(e.target.value)} id="wallemails" style={{ height: '78px' }}></textarea> <span id="wallemailserror" className="errorMessage required">
              </span>
              <button type="submit" onClick={(e) => sendCodeNew(e)} className={`${loader ? 'ladda-button spinner spinner-white spinner-right disabled ' : ''} btn btn-primary btn-lg w-100 mt-5`} data-factors-bind="true" data-factors-click-bind="true">Share URL</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ShareEmailCampaignCode
